<template>
  <div>
    <el-table :data="tableData" height="calc(100% - 50px)" border stripe v-loading="loading">
      <el-table-column width="100" type="index" label="序号/场次"></el-table-column>
      <el-table-column prop="examName" label="试卷名称"></el-table-column>
      <el-table-column prop="examCategoryText" label="考试类型"></el-table-column>
      <el-table-column prop="makeUpExam" label="是否补考">
        <template slot-scope="scope">
          {{ scope.row.makeUpExam ? '是' : '否' }}
        </template>
      </el-table-column>
      <el-table-column prop="coursewareTimes" label="考试时间" width="300">
        <template slot-scope="scope">
          <span>{{ scope.row | showText('time') }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="answerTime" label="考试时长(min)" width="140"></el-table-column>
      <el-table-column prop="pass" label="是否通过">
        <template slot-scope="scope">
          <div>
            {{ scope.row.pass ? '是' : '否' }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="customerScore" label="得分"></el-table-column>
    </el-table>
    <el-pagination
      class="mt-20px text-right"
      background
      :current-page.sync="page.pageNo"
      @size-change="searchList"
      @current-change="findList"
      :page-sizes="[15, 30, 45, 60, 75, 90]"
      :page-size.sync="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    ></el-pagination>
  </div>
</template>

<script>
import { TaskExamAnswerRecordApi } from '@wiz-api/exam-management'
import dayjs from 'dayjs'

const taskExamAnswerRecordApi = new TaskExamAnswerRecordApi()
export default {
  name: 'personExamRecord',
  props: {
    userId: {
      type: String,
      default: '',
    },
  },
  methods: {
    searchList() {
      this.page.pageNo = 1
      this.findList()
    },
    async findList() {
      if (!this.userId) return
      this.loading = true
      const [err, res] = await taskExamAnswerRecordApi.examineePageList({
        userId: this.userId,
        skipCount: (this.page.pageNo - 1) * this.page.pageSize,
        maxResultCount: this.page.pageSize,
      })
      this.loading = false
      if (!err) {
        this.tableData = res.items
        this.total = res.totalCount
      }
    },
  },
  data() {
    return {
      tableData: [],
      page: {
        pageNo: 1,
        pageSize: 15,
      },
      total: 0,
      loading: false,
    }
  },
  filters: {
    showText: (val, type) => {
      let result = ''
      if (type === 'time') {
        if (val.examStartTime && val.examEndTime) {
          result = `${dayjs(val.examStartTime).format('YYYY-MM-DD HH:mm')} - ${dayjs(
            val.examEndTime
          ).format('YYYY-MM-DD HH:mm')}`
        } else if (val.examStartTime) {
          result = `${dayjs(val.examStartTime).format('YYYY-MM-DD HH:mm')} - 无`
        }
      }
      return result
    },
  },
  async created() {
    this.findList()
  },
}
</script>

<style></style>
